import { ReactElement } from 'react';
import { Row, Col, Statistic } from 'antd';
import { Typography } from 'iglooform';
import './earnings-list.less';
import moment from 'moment';
import { useIntl } from 'react-intl';

interface IEarningList {
  data: EarningsListProps[];
  isPc: boolean;
  isPoints: boolean;
  currentLang: string;
}

const EarningList = ({
  isPc,
  data,
  currentLang,
}: IEarningList): ReactElement => {
  const { formatMessage } = useIntl();

  return (
    <>
      {isPc
        ? data.map((earning: EarningsListProps) => (
            <Row key={earning.policy_id} className="list-container">
              <Col span={6}>
                <Typography level="body1">{`${earning.product_name}`}</Typography>
              </Col>
              <Col span={6}>
                <Typography level="body1">{earning.customer_name}</Typography>
              </Col>
              <Col span={6}>
                <Typography level="body1">
                  {moment(earning.create_at * 1000).format('DD / MM / YYYY')}
                </Typography>
              </Col>
              <Col span={6}>
                <Statistic
                  value={earning.amount}
                  prefix={`+ ${formatMessage({ id: 'VND' })}`}
                  groupSeparator={currentLang === 'vi-VN' ? '.' : ','}
                  decimalSeparator={currentLang === 'vi-VN' ? ',' : '.'}
                  valueStyle={{ color: '#5858FF' }}
                  className="statistic"
                />
              </Col>
            </Row>
          ))
        : data.map((earning: EarningsListProps) => (
            <div
              key={earning.policy_id}
              style={{
                padding: '12px 0',
                borderTop: '1px solid #eee',
                marginLeft: '-12px',
                marginRight: '16px',
              }}
            >
              <Typography
                level="body1"
                wrapElement="div"
              >{`${earning.product_name}`}</Typography>
              <Typography level="body1" wrapElement="div">
                {earning.customer_name}
              </Typography>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                }}
              >
                <Typography level="body2" style={{ color: '#999' }}>
                  {moment(earning.create_at * 1000).format('DD / MM / YYYY')}
                </Typography>
                <Statistic
                  value={earning.amount}
                  prefix={`+ ${formatMessage({ id: 'VND' })}`}
                  groupSeparator={currentLang === 'vi-VN' ? '.' : ','}
                  decimalSeparator={currentLang === 'vi-VN' ? ',' : '.'}
                  valueStyle={{
                    color: '#5858FF',
                    fontSize: '16px',
                    fontWeight: '700',
                  }}
                  className="statistic"
                />
              </div>
            </div>
          ))}
    </>
  );
};

export default EarningList;
